import { FormikProps } from 'formik';
import { PurchaseOrderStatus } from 'src/models/enums/PurchaseOrderStatus.enum';

export const calculatePurchaseOrderDialogHeight = (
  formik: FormikProps<any>
) => {
  const firstGroupHasError =
    (formik.touched.vendor && formik.errors.vendor) ||
    (formik.touched.deliveryAddress && formik.errors.deliveryAddress);

  const secondGroupHasError =
    formik.touched.purchaseOrderItems && formik.errors.purchaseOrderItems;

  const baseHeight = 720;
  const errorHeight =
    (firstGroupHasError ? 20 : 0) + (secondGroupHasError ? 20 : 0);
  return baseHeight + errorHeight;
};

export const isPurchaseOrderStatus = (
  status: string,
  targetStatus: PurchaseOrderStatus
) => {
  return status === targetStatus;
};

export const canEditPurchaseOrder = (status: string) => {
  return [PurchaseOrderStatus.NEW, PurchaseOrderStatus.PENDING].includes(
    status as PurchaseOrderStatus
  );
};

export const canViewPurchaseOrder = (status: string) => {
  return [PurchaseOrderStatus.APPROVED, PurchaseOrderStatus.REJECTED].includes(
    status as PurchaseOrderStatus
  );
};

export const canUpdatePurchaseOrderStatus = (status: string) => {
  return status === PurchaseOrderStatus.PENDING;
};

export const canCreateGRN = (status: string) => {
  return status === PurchaseOrderStatus.APPROVED;
};

export const canDeletePurchaseOrder = (status: string) => {
  return [PurchaseOrderStatus.NEW, PurchaseOrderStatus.PENDING].includes(
    status as PurchaseOrderStatus
  );
};
